import mrpStyles from './../mrp.json'

// TODO: SHOP-3672 - YCOS | Align Font Styles Configuration Files - https://jira.nap/browse/SHOP-3672
const titleStyles = {
  fontWeight: '500',
  fontSize: '24px',
  lineHeight: '1.25',
  textTransform: 'none',
  color: mrpStyles.colors.PrimaryBlack,
  colorGold: mrpStyles.colors.SecondaryGold,
  textAlign: 'center',
  'screen-large': {
    fontSize: '32px'
  }
}

const textStyles = {
  name: '1',
  type: 'Label'
}

export default {
  titleStyles,
  textStyles
}
